import React, { useState, useRef, useEffect } from "react";
import Profile from "../Pages/Profie";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { API, UPLOADS } from "./../../config/api";
import "./../Styles/Navbar.css";
import "./../Styles/contact.css";
import "./../Styles/Home.css";
import "./../Styles/footer.css";
import "./../Styles/machines.css";
import "./../Styles/ProductDetails.css";
import "./../Styles/house.css";
import "./../Styles/designer.css";
import "./../Styles/wishlist.css";
import "./../Styles/login.css";
import "./../Styles/about.css";
import "./../Styles/ragister.css";
import "./../Styles/HouseRentDetails.css";
import "./../Styles/designerdetails.css";
import "./../Styles/theme.css";

export default function Navbar() {
  const location = useLocation();
  const [showprofile, setShowprofile] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("all");
  const dropdownRef = useRef();

  // Inside Navbar.jsx logic...

  const [counts, setCounts] = useState({ wishlist: 0, cart: 0, orders: 0 });

  const updateLocalCounts = () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));

    if (loginUser) {
      // 1. Get raw data from localStorage
      const localCart =
        JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
      const localWishlist =
        JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];

      // 2. Update state with the lengths
      setCounts((prev) => ({
        ...prev,
        cart: localCart.length,
        wishlist: localWishlist.length,
      }));

      // 3. Fetch orders from Database
      fetchOrdersCount(loginUser.id);
    } else {
      // Reset counts if no user is logged in
      setCounts({ wishlist: 0, cart: 0, orders: 0 });
    }
  };

  const fetchOrdersCount = async (userId) => {
    try {
      const res = await fetch(` ${API.COUNTS1}&user_id=${userId}`);
      const data = await res.json();
      setCounts((prev) => ({ ...prev, orders: data.orders_count || 0 }));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    updateLocalCounts();

    // This must match the name in dispatchEvent
    window.addEventListener("cartUpdated", updateLocalCounts);
    window.addEventListener("userLogin", updateLocalCounts);

    return () => {
      window.removeEventListener("cartUpdated", updateLocalCounts);
      window.removeEventListener("userLogin", updateLocalCounts);
    };
  }, []);
  /* ================= LOAD USER ================= */
  useEffect(() => {
    const loadUser = () => {
      const loginUser = JSON.parse(sessionStorage.getItem("user"));
      setUser(loginUser);
    };

    loadUser();

    window.addEventListener("userLogin", loadUser);
    window.addEventListener("userLogout", loadUser);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", loadUser);
    };
  }, []);

  /* ================= CLICK OUTSIDE ================= */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  /* ================= LOGOUT ================= */
  const navigate = useNavigate();
  const handleLogout = () => {
    sessionStorage.removeItem("user");

    setUser(null);

    window.dispatchEvent(new Event("userLogout"));

    setAccountOpen(false);

    navigate("/");
  };
  /* ================= SEARCH ================= */

  const handleSearch = () => {
    if (!search.trim()) return;

    navigate(`/search?query=${search}&type=${category}`);
  };
  return (
    <>
      {/* ================= TOP HEADER ================= */}

      <div className="top-header">
        <div className="container-fluid header-container">
          {/* LOGO */}

          <div className="logo">
            <span className="logo-dark">Stitch</span>
            <span className="logo-light">Mart</span>
          </div>

          {/* SEARCH */}
          <div className="search-box">
            <div className="search-input-group">
              <select
                className="search-category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <option value="all">All</option>
                <option value="designer">Designers</option>
                <option value="machine">Machines</option>
                <option value="workspace">Workspace</option>
              </select>

              <input
                type="text"
                className="main-search-input"
                placeholder="Search city, skill, machine..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
              />

              <button className="search-submit-btn" onClick={handleSearch}>
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>

          {/* ACCOUNT */}

          <div className="account-section" ref={dropdownRef}>
            <div className="dropdown">
              <button
                className="account-btn"
                onClick={() => setAccountOpen(!accountOpen)}
              >
                <i className="bi bi-person"> </i>
                {user ? user.name : "My Account"}
              </button>

              <div className={`dropdown-menu ${accountOpen ? "show" : ""}`}>
                {user ? (
                  <>
                    <div className="dropdown-user">
                      <i className="bi bi-person-circle"></i>
                      <span>{user.name}</span>
                    </div>

                    <hr />

                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowprofile(true);
                        setAccountOpen(false);
                      }}
                    >
                      Profile
                    </Link>
                    {/* Show only if account_type = provider OR role = admin */}
                    {user &&
                      (user?.account_type === "provider" ||
                        user?.role === "admin") && (
                        <Link
                          to={user?.role === "admin" ? "/admin" : "/user"}
                          onClick={() => setAccountOpen(false)}
                          className="provider-panel-btn"
                        >
                          Go To Dashboard
                        </Link>
                      )}
                    <button
                      className="dropdown-item logout-btn"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowLogin(true);
                        setAccountOpen(false);
                      }}
                    >
                      Login
                    </Link>

                    <Link
                      to="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setShowRegister(true);
                        setAccountOpen(false);
                      }}
                    >
                      Sign Up
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= MAIN NAVBAR ================= */}

      <div className="main-navbar">
        <div className="container-fluid nav-container">
          <div className="mobile-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <i className="bi bi-list"></i>
          </div>

          <div className={`nav-links ${menuOpen ? "active" : ""}`}>
            <Link
              to="/Home"
              className={location.pathname === "/Home" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>

            <Link
              to="/About"
              className={location.pathname === "/About" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              About us
            </Link>
            <Link
              to="/designes"
              className={location.pathname === "/designes" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Free Designes
            </Link>

            <Link
              to="/machine"
              className={location.pathname === "/machine" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Embroidery Machines
            </Link>

            <Link
              to="/house"
              className={location.pathname === "/house" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Rent Workspace
            </Link>

            <Link
              to="/designer"
              className={location.pathname === "/designer" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Hire Designers
            </Link>

            <Link
              to="/Contact"
              className={location.pathname === "/Contact" ? "active-link" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
          </div>

          {/* ... mobile toggle and links ... */}
          <div className="navbar-interaction-group">
            <Link to="/wishlist" className="nav-item-container">
              <i className="bi bi-heart"></i>
              {counts.wishlist > 0 && (
                <span className="status-indicator">{counts.wishlist}</span>
              )}
            </Link>

            {/* <Link to="/cart" className="nav-item-container">
              <i className="bi bi-cart"></i>
              {counts.cart > 0 && (
                <span className="status-indicator">{counts.cart}</span>
              )}
            </Link>

            <Link
              to="/myorders"
              className="nav-item-container"
              title="My Orders"
            >
              <i className="bi bi-bag-check"></i>
              {counts.orders > 0 && (
                <span className="status-indicator status-green">
                  {counts.orders}
                </span>
              )}
            </Link> */}
          </div>
        </div>
      </div>

      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
      />

      <Register
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        openLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />
      {showprofile && (
        <Profile isOpen={showprofile} onClose={() => setShowprofile(false)} />
      )}
    </>
  );
}
